import { render, staticRenderFns } from "./StoreDerek.vue?vue&type=template&id=f4783546&"
import script from "./StoreDerek.vue?vue&type=script&lang=js&"
export * from "./StoreDerek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports